import { render, staticRenderFns } from "./CaseDocumentsManager.vue?vue&type=template&id=ba464502&scoped=true"
import script from "./CaseDocumentsManager.vue?vue&type=script&lang=js"
export * from "./CaseDocumentsManager.vue?vue&type=script&lang=js"
import style0 from "./CaseDocumentsManager.vue?vue&type=style&index=0&id=ba464502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba464502",
  null
  
)

export default component.exports